var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon9({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 100,
    viewBox: "0 0 106 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4072 57.3855L16.4068 57.3841C15.7009 54.4389 15.3281 51.3627 15.3281 48.1977C15.3281 26.4562 32.9531 8.83125 54.6945 8.83125C76.436 8.83125 94.061 26.4562 94.0614 48.1972C94.0614 53.3216 93.0813 58.2144 91.3019 62.7022C89.1777 61.8242 86.853 61.3398 84.4203 61.3398C74.4675 61.3398 66.3512 69.4588 66.3512 79.4117C66.3512 81.5327 66.7188 83.573 67.395 85.4685C63.4109 86.826 59.1399 87.5641 54.6948 87.5641C44.8356 87.5641 35.827 83.942 28.919 77.9552C24.2872 73.9384 20.6028 68.8591 18.2467 63.098L18.2462 63.0969C17.4924 61.2603 16.8756 59.3525 16.4072 57.3855Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64062 15.2578C11.6782 15.2578 13.3281 16.9078 13.3281 18.9453C13.3281 20.9829 11.6782 22.6328 9.64062 22.6328C7.60307 22.6328 5.95312 20.9829 5.95312 18.9453C5.95312 16.9078 7.60307 15.2578 9.64062 15.2578Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.734 9.57031C104.734 12.9013 102.034 15.6016 98.7031 15.6016C95.3722 15.6016 92.6719 12.9013 92.6719 9.57031C92.6719 6.23935 95.3722 3.53906 98.7031 3.53906C102.034 3.53906 104.734 6.23935 104.734 9.57031Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6125 79.4117C95.6125 73.2591 90.5881 68.2334 84.4226 68.2334C78.267 68.2334 73.2422 73.2586 73.2417 79.4117H95.6125ZM95.6125 79.4117C95.6125 85.5766 90.5875 90.6016 84.4226 90.6016M95.6125 79.4117L84.4226 90.6016M84.4226 90.6016C78.2676 90.6016 73.2417 85.5771 73.2417 79.4118L84.4226 90.6016Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0576 79.1445C57.0576 77.8387 55.9987 76.7812 54.6943 76.7812C53.3881 76.7812 52.331 77.8381 52.3306 79.1445H57.0576ZM57.0576 79.1445C57.0576 80.4509 55.9986 81.5083 54.6943 81.5083M57.0576 79.1445L54.6943 81.5083M54.6943 81.5083C53.3876 81.5083 52.3307 80.4514 52.3306 79.1448L54.6943 81.5083Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8105 67.7156C34.1164 67.7156 35.1738 68.7745 35.1738 70.0789C35.1738 71.386 34.116 72.4443 32.8105 72.4443C31.5051 72.4443 30.4473 71.3858 30.4473 70.0789C30.4473 68.7745 31.5047 67.7156 32.8105 67.7156Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6411 45.8344C86.948 45.8344 88.0049 46.8914 88.0049 48.1977C88.0049 49.502 86.9475 50.5609 85.6411 50.5609C84.3353 50.5609 83.2778 49.5021 83.2778 48.1977C83.2778 46.8913 84.3348 45.8344 85.6411 45.8344Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5757 23.9508C77.8829 23.9508 78.9413 25.0087 78.9413 26.3141C78.9413 27.6194 77.8825 28.6773 76.5757 28.6773C75.2713 28.6773 74.2124 27.6199 74.2124 26.3141C74.2124 25.0082 75.2713 23.9508 76.5757 23.9508Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0576 17.2508C57.0576 15.944 55.9978 14.8852 54.6943 14.8852C53.389 14.8852 52.331 15.9434 52.3306 17.2508H57.0576ZM57.0576 17.2508C57.0576 18.5547 55.9983 19.6141 54.6943 19.6141M57.0576 17.2508L54.6943 19.6141M54.6943 19.6141C53.388 19.6141 52.3307 18.5552 52.3306 17.251L54.6943 19.6141Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8105 23.9508C34.1169 23.9508 35.1738 25.0078 35.1738 26.3141C35.1738 27.6204 34.1169 28.6773 32.8105 28.6773C31.5042 28.6773 30.4473 27.6204 30.4473 26.3141C30.4473 25.0078 31.5042 23.9508 32.8105 23.9508Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7475 45.8344C25.0519 45.8344 26.1107 46.8918 26.1107 48.1977C26.1107 49.5016 25.0514 50.5609 23.7475 50.5609C22.4407 50.5609 21.3818 49.5012 21.3818 48.1977C21.3818 46.8923 22.4402 45.8344 23.7475 45.8344Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.562 28.9062C103.562 29.3248 103.223 29.6641 102.805 29.6641C102.386 29.6641 102.047 29.3248 102.047 28.9062C102.047 28.4877 102.386 28.1484 102.805 28.1484C103.223 28.1484 103.562 28.4877 103.562 28.9062Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.219 64.0625C101.219 64.481 100.879 64.8203 100.461 64.8203C100.042 64.8203 99.7031 64.481 99.7031 64.0625C99.7031 63.644 100.042 63.3047 100.461 63.3047C100.879 63.3047 101.219 63.644 101.219 64.0625Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2969 1.95312C81.2969 2.37165 80.9576 2.71094 80.5391 2.71094C80.1205 2.71094 79.7812 2.37165 79.7812 1.95312C79.7812 1.5346 80.1205 1.19531 80.5391 1.19531C80.9576 1.19531 81.2969 1.5346 81.2969 1.95312Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9922 98.0469C68.9922 98.4654 68.6529 98.8047 68.2344 98.8047C67.8158 98.8047 67.4766 98.4654 67.4766 98.0469C67.4766 97.6283 67.8158 97.2891 68.2344 97.2891C68.6529 97.2891 68.9922 97.6283 68.9922 98.0469Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5938 92.1875C35.5938 92.606 35.2545 92.9453 34.8359 92.9453C34.4174 92.9453 34.0781 92.606 34.0781 92.1875C34.0781 91.769 34.4174 91.4297 34.8359 91.4297C35.2545 91.4297 35.5938 91.769 35.5938 92.1875Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 6.64062C33.25 7.05915 32.9107 7.39844 32.4922 7.39844C32.0737 7.39844 31.7344 7.05915 31.7344 6.64062C31.7344 6.2221 32.0737 5.88281 32.4922 5.88281C32.9107 5.88281 33.25 6.2221 33.25 6.64062Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 34.7656C5.125 35.1842 4.78572 35.5234 4.36719 35.5234C3.94866 35.5234 3.60938 35.1842 3.60938 34.7656C3.60938 34.3471 3.94866 34.0078 4.36719 34.0078C4.78572 34.0078 5.125 34.3471 5.125 34.7656Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6585 48.3698H38.5483C38.4535 48.3698 38.3765 48.2927 38.3765 48.1979C38.3765 48.1031 38.4535 48.026 38.5483 48.026H50.6585C50.7533 48.026 50.8304 48.1031 50.8304 48.1979C50.8304 48.2927 50.7533 48.3698 50.6585 48.3698Z",
    fill: "#4D2481",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6943 44.3313C54.5993 44.3313 54.5225 44.2545 54.5225 44.1594V26.668C54.5225 26.5729 54.5993 26.4961 54.6943 26.4961C54.7893 26.4961 54.8662 26.573 54.8662 26.668V44.1594C54.8662 44.2543 54.7893 44.3313 54.6943 44.3313Z",
    fill: "#4D2481",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4204 97.6328C84.3254 97.6328 84.2485 97.556 84.2485 97.4609C84.2485 97.3659 84.3254 97.2891 84.4204 97.2891C94.2804 97.2891 102.3 89.2692 102.3 79.4094C102.3 79.3142 102.377 79.2375 102.472 79.2375C102.567 79.2375 102.644 79.3142 102.644 79.4094C102.644 89.4569 94.468 97.6328 84.4204 97.6328Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3594 57.7891H3.78125C3.6863 57.7891 3.60938 57.7121 3.60938 57.6172C3.60938 57.5223 3.6863 57.4453 3.78125 57.4453H21.3594C21.4543 57.4453 21.5312 57.5223 21.5312 57.6172C21.5312 57.7121 21.4543 57.7891 21.3594 57.7891Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3906 63.6484H10.8125C10.7175 63.6484 10.6406 63.5715 10.6406 63.4766C10.6406 63.3816 10.7175 63.3047 10.8125 63.3047H28.3906C28.4856 63.3047 28.5625 63.3816 28.5625 63.4766C28.5625 63.5715 28.4856 63.6484 28.3906 63.6484Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 70.6797H1.4375C1.34255 70.6797 1.26562 70.6027 1.26562 70.5078C1.26562 70.4129 1.34255 70.3359 1.4375 70.3359H15.5C15.595 70.3359 15.6719 70.4129 15.6719 70.5078C15.6719 70.6027 15.595 70.6797 15.5 70.6797Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7656 78.8828H8.46875C8.3738 78.8828 8.29688 78.8059 8.29688 78.7109C8.29688 78.616 8.3738 78.5391 8.46875 78.5391H37.7656C37.8606 78.5391 37.9375 78.616 37.9375 78.7109C37.9375 78.8059 37.8606 78.8828 37.7656 78.8828Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6719 84.7422H2.60938C2.51442 84.7422 2.4375 84.6652 2.4375 84.5703C2.4375 84.4754 2.51442 84.3984 2.60938 84.3984H16.6719C16.7668 84.3984 16.8438 84.4754 16.8438 84.5703C16.8438 84.6652 16.7668 84.7422 16.6719 84.7422Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6946 45.1594C56.3705 45.1594 57.7306 46.5203 57.7306 48.1977C57.7306 49.8742 56.3713 51.2334 54.6946 51.2334C53.0178 51.2334 51.6582 49.8741 51.6582 48.1977C51.6582 46.5205 53.0188 45.1594 54.6946 45.1594Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8039 83.1398C87.9402 82.8563 88.0072 82.5355 88.0073 82.1659C88.0069 81.3616 87.7753 80.9079 87.4498 80.6268C87.0159 80.2528 86.292 79.9009 85.1837 79.6323L87.8039 83.1398ZM87.8039 83.1398C87.9117 82.8715 87.968 82.5782 87.968 82.265C87.968 81.5109 87.6508 80.853 87.0273 80.4073C86.5135 80.04 85.7533 79.7788 84.8816 79.5692C84.0437 79.3675 83.4489 79.1927 83.0707 79.0458L83.0686 79.045C82.7163 78.9091 82.4163 78.7358 82.1605 78.529L82.1482 78.5191L82.1355 78.5095C81.7614 78.2262 81.5044 77.7652 81.5044 76.9201C81.5044 76.5641 81.5586 76.2647 81.6632 76.0093M87.8039 83.1398L81.6632 76.0093M81.6632 76.0093C81.5828 76.2506 81.5432 76.5096 81.5432 76.7795C81.5432 77.5548 81.8687 78.2337 82.5258 78.6824L82.5263 78.6828C82.8202 78.8832 83.2062 79.0469 83.6195 79.1895C84.0482 79.3375 84.5721 79.4846 85.1831 79.6322L81.6632 76.0093Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon-9.3df8eda7417e606d84321011dfd3bd04.svg";
export { ForwardRef as ReactComponent };